import { useState } from 'react';

function FilterBar({ politicians, onFilteredResults, showStateFilter = true }) {
    const [partyFilter, setPartyFilter] = useState('all');
    const [stateFilter, setStateFilter] = useState('all');
    const [ageFilter, setAgeFilter] = useState('all');

    // Get unique values for dropdowns
    const parties = ['all', ...new Set(politicians.map(p => p.party))];
    const states = ['all', ...new Set(politicians.map(p => p.state).filter(Boolean))];

    // Filter politicians whenever filters change
    const applyFilters = (party, state, age) => {
        let filtered = politicians;

        // Party filter
        if (party !== 'all') {
            filtered = filtered.filter(p => p.party === party);
        }

        // State filter
        if (state !== 'all') {
            filtered = filtered.filter(p => p.state === state);
        }

        // Age filter
        if (age !== 'all') {
            if (age === 'young') {
                filtered = filtered.filter(p => p.age < 45);
            } else if (age === 'middle') {
                filtered = filtered.filter(p => p.age >= 45 && p.age < 60);
            } else if (age === 'senior') {
                filtered = filtered.filter(p => p.age >= 60);
            }
        }

        onFilteredResults(filtered);
    };

    const handlePartyChange = (e) => {
        const value = e.target.value;
        setPartyFilter(value);
        applyFilters(value, stateFilter, ageFilter);
    };

    const handleStateChange = (e) => {
        const value = e.target.value;
        setStateFilter(value);
        applyFilters(partyFilter, value, ageFilter);
    };

    const handleAgeChange = (e) => {
        const value = e.target.value;
        setAgeFilter(value);
        applyFilters(partyFilter, stateFilter, value);
    };

    const clearFilters = () => {
        setPartyFilter('all');
        setStateFilter('all');
        setAgeFilter('all');
        onFilteredResults(politicians);
    };

    return (
        <div className="filter-bar">
            <div className="filter-section">
                <h3>Filters</h3>
                <div className="filters">
                    <div className="filter-group">
                        <label htmlFor="party">Party:</label>
                        <select id="party" value={partyFilter} onChange={handlePartyChange}>
                            {parties.map(party => (
                                <option key={party} value={party}>
                                    {party === 'all' ? 'All Parties' : party}
                                </option>
                            ))}
                        </select>
                    </div>

                    {showStateFilter && (
                        <div className="filter-group">
                            <label htmlFor="state">State:</label>
                            <select id="state" value={stateFilter} onChange={handleStateChange}>
                                {states.map(state => (
                                    <option key={state} value={state}>
                                        {state === 'all' ? 'All States' : state}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="filter-group">
                        <label htmlFor="age">Age Group:</label>
                        <select id="age" value={ageFilter} onChange={handleAgeChange}>
                            <option value="all">All Ages</option>
                            <option value="young">Under 45</option>
                            <option value="middle">45-59</option>
                            <option value="senior">60+</option>
                        </select>
                    </div>

                    <button onClick={clearFilters} className="clear-filters">
                        Clear All Filters
                    </button>
                </div>
            </div>

            <div className="results-count">
                Showing {politicians.length} politicians
            </div>
        </div>
    );
}

export default FilterBar;